import { ImageBackground } from 'expo-image';

import { createMqStyles, useMqSelect } from '@fhs/ui';
import { useClickLogs } from '@fhs-legacy/frontend/src/hooks/use-click-logs';

import { CtaButton } from '../shared/cta-button';

export function TripleStackCard({ url }: { url: string }) {
  const mqStyles = useMqStyles();
  const backgroundSource = useMqSelect(
    {
      $gteDesktopLg: require('./desktop.webp'),
    },
    require('./tablet.webp')
  );

  const { logLTOCardClickEvent } = useClickLogs();
  const handleButtonClick = () => {
    logLTOCardClickEvent("Smokin' BBQ Triple Stack");
  };

  return (
    <ImageBackground
      alt="Smokin' BBQ Triple Stack. Available in classic or New! Carolina Gold."
      source={backgroundSource}
      placeholder={{ thumbhash: 'bUkGC4KvpoVdhciSMIAAUTs=' }}
      style={mqStyles.background}
    >
      <CtaButton href={url} style={mqStyles.button} onPress={handleButtonClick} />
    </ImageBackground>
  );
}

const useMqStyles = createMqStyles({
  background: {
    $base: {
      aspectRatio: 1024 / 504,
    },
    $gteDesktopLg: {
      aspectRatio: 1920 / 757,
    },
  },
  button: {
    $base: {
      position: 'absolute',
      top: '55%',
      left: '28%',
      transform: 'translateX(-50%)',
    },
    $gteDesktopLg: {
      top: '60%',
    },
  },
});
